import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import GetSingleUserRequest from "../../../Controllers/SuperAdmin/GetSingleUserRequest";

const UserRequestsDetailsViewModel = () => {
  const location = useLocation();
  const [RequestDetails, setRequestDetails] = useState({});
  const [IsLoading, setIsLoading] = useState(false);
  const [RequestId, setRequestId] = useState("");

  useEffect(() => {
    const Id = location.pathname.split("/").pop();
    setRequestId(Id);
  }, [location.pathname]);

  useEffect(() => {
    async function fetchData() {
      setIsLoading(true);
      const requestData = await GetSingleUserRequest(RequestId);
      setRequestDetails(requestData);
      setIsLoading(false);
    }
    fetchData();
  }, [RequestId]);

  return {
    RequestDetails,
    IsLoading,
  };
};

export default UserRequestsDetailsViewModel;
